module.exports = __webpack_public_path__ + "img/175.d539f29.svg";